import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationWSearchInput } from '../../../../types/schema/utils.types';
import { User } from '../../../../types/schema/user.types';

interface GetAllUsersBySearchByPageHook {
  data: User[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllUsersBySearchByPage: User[];
    }>
  >;
}

interface GetAllUsersBySearchByPageMutationData {
  getAllUsersBySearchByPage: User[];
}

interface GetAllUsersBySearchByPageInputType {
  input: PaginationWSearchInput;
}

export function useGetAllUsersBySearchByPage(
  query: DocumentNode,
  input: PaginationWSearchInput
): GetAllUsersBySearchByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllUsersBySearchByPageMutationData,
    GetAllUsersBySearchByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllUsersBySearchByPage,
    loading,
    error,
    refetch,
  };
}
